import React from "react";

// These are presentation tokens from the authoritative prototype. Capacity
// thresholds intentionally do not live here: the API remains their source.
export const CAPACITY_STATUSES = Object.freeze({
  frei: Object.freeze({ key: "frei", label: "verfügbar", legendLabel: "verfügbar (bis zu 1 Tag) — 0 bis 33", symbol: "○", className: "capacity-status-frei", colorToken: "--capacity-frei" }),
  Puffer: Object.freeze({ key: "puffer", label: "ausgelastet mit ein wenig Puffer", legendLabel: "ausgelastet mit ein wenig Puffer — 34 bis 41", symbol: "◆", className: "capacity-status-puffer", colorToken: "--capacity-puffer" }),
  ausgelastet: Object.freeze({ key: "ausgelastet", label: "ausgelastet", legendLabel: "ausgelastet — 42 bis 46", symbol: "●", className: "capacity-status-ausgelastet", colorToken: "--capacity-ausgelastet" }),
  Konflikt: Object.freeze({ key: "konflikt", label: "Konflikt in der Planung/Überlastung", legendLabel: "Konflikt in der Planung/Überlastung — 47 und mehr", symbol: "!", className: "capacity-status-konflikt", colorToken: "--capacity-konflikt" }),
});

export const CAPACITY_LEGEND = Object.freeze(
  Object.values(CAPACITY_STATUSES).map(({ key, legendLabel: label, className }) =>
    Object.freeze({ key, label, className }),
  ),
);

export const capacityStatus = status => CAPACITY_STATUSES[status] || CAPACITY_STATUSES.frei;

export function CapacityStatus({ status, className = "" }) {
  const token = capacityStatus(status);
  return <span className={`capacity-status ${token.className} ${className}`.trim()} aria-label={`Kapazitätsstatus: ${token.label}`}>
    <span className="capacity-status-symbol" aria-hidden="true">{token.symbol}</span>
    <span>{token.label}</span>
  </span>;
}
